module.exports = "/images/ny-street-6.jpg";